import qs from 'qs';

const base = {
  appName: 'PARC Portal',
  oAuth: {
    clientId: 'nike.pes.parc-app-portal',
    responseType: 'id_token token',
    scope: 'profile openid email',
  },
};

const oAuthEndpoint = window.location.host.split ('.')[0] ===
  'prod-parc-app-dashboard'
  ? 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize'
  : 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize';

const envConfig = {
  oAuth: {
    redirectUri: window.location.origin,
    authorization: oAuthEndpoint,
    ...base.oAuth,
  },
  appName: base.appName,
};

const tokenBase = {
  get isExpired () {
    return this.expiresAt * 1000 < Date.now ();
  },
};
const makeToken = token =>
  token ? Object.assign (Object.create (tokenBase), token) : null;
const exists = obj => obj !== undefined && obj !== null;

const getOktaUrl = envConfig => {
  return (
    envConfig.oAuth.authorization +
    '?' +
    qs.stringify ({
      response_type: envConfig.oAuth.responseType,
      client_id: envConfig.oAuth.clientId,
      policy_group_id: envConfig.oAuth.policyGroupId,
      scope: envConfig.oAuth.scope,
      redirect_uri: envConfig.oAuth.redirectUri,
      nonce: '1',
      state: '1',
    })
  );
};

export const login = () => {
  const href = getOktaUrl (envConfig);
  window.location.href = href;
};

export const logout = () => {
  localStorage.removeItem ('token');
};

const parseRedirectToken = value => {
  if (!value || !value.length) return null;
  if (value[0] === '#') value = value.substring (1);
  let token = qs.parse (value);
  if (token.error) {
    console.log (
      `Error logging in: ${token.error_description || 'Unknown Error'}`
    );
    return {
      tokenError: `Error logging in: ${token.error_description || 'Unknown Error'}`,
    };
  }
  // Check that this is an oauth redirection, not a normal app route
  return token;
};

export const checkForToken = () => {
  // Parse the token
  const existingtoken = makeToken (JSON.parse (localStorage.getItem ('token')));
  //return token if it exists and is not expired
  if (existingtoken && !existingtoken.isExpired) {
    return existingtoken;
  } else {
    let token = parseRedirectToken (window.location.hash);
    if (exists (token)) {
      if (token.tokenError) return token;
      window.location.hash = '';
      token = unpackEncodedToken (token);
      token = makeToken (token);
      if (token.accessToken) {
        localStorage.setItem ('token', JSON.stringify (token));
        return token;
      }
    }
    return null;
  }
};

const parseJwtPayload = payload => {
  return JSON.parse (window.atob (payload));
};

const unpackEncodedToken = token => {
  if (!token || !token.access_token) return null;

  let accessValues = token.access_token.split ('.');
  let openIdValues = token.id_token.split ('.');
  let accessClaims = parseJwtPayload (accessValues[1]);
  let openIdClaims = parseJwtPayload (openIdValues[1]);

  // The name of these values will depend on the token issuer
  // Ping and Okta have different values for scope and username
  return {
    accessToken: token.access_token,
    openIdToken: token.id_token,
    expiresIn: token.expires_in,
    expiresAt: accessClaims.exp,
    username: accessClaims.sub,
    email: openIdClaims.email,
    firstName: openIdClaims.given_name,
    lastName: openIdClaims.family_name,
    scope: accessClaims.scope,
    state: token.state,
  };
};
